import React from "react";
import { useAuth } from "../context/AuthContext";

export default function HelpPage() {
  const { user } = useAuth();
  const appVersion =
    (typeof process !== "undefined" && process.env && process.env.REACT_APP_VERSION) ||
    "";

  return (
    <div className="max-w-3xl mx-auto p-6">
      <h1 className="text-2xl font-bold text-blue-900 mb-2">Nápověda</h1>
      <div className="text-sm text-gray-600 mb-6">
        Přihlášen:{" "}
        <span className="font-medium">
          {user?.username} ({user?.role})
        </span>
        {user?.firma ? (
          <>
            {" "}
            • Firma: <span className="font-medium">{user.firma}</span>
          </>
        ) : null}
        {user?.pharmacyCode ? (
          <>
            {" "}
            • Pobočka: <span className="font-medium">{user.pharmacyCode}</span>
          </>
        ) : null}
        {appVersion ? (
          <>
            {" "}
            • Verze: <span className="font-medium">{appVersion}</span>
          </>
        ) : null}
      </div>

      <div className="space-y-4">
        <div className="border rounded-xl p-4">
          <div className="font-semibold mb-2">Rychlé tipy</div>
          <ul className="list-disc pl-5 text-sm text-gray-700 space-y-1">
            <li>Pokud něco nesedí, zkuste refresh (Ctrl+R).</li>
            <li>Po každém nahrání exportů se přepočítají přehledy (pokud je to zapnuté).</li>
            <li>V plánování směn ověřte měsíc/rok a vybranou pobočku.</li>
          </ul>
        </div>

        <div className="border rounded-xl p-4">
          <div className="font-semibold mb-2">Časté dotazy (FAQ)</div>
          <div className="text-sm text-gray-700 space-y-3">
            <div>
              <div className="font-medium">Kam hlásit chybu?</div>
              <div className="text-gray-600">
                Vpravo nahoře v menu klikněte na <b>Nahlásit problém</b>.
                Otevře se e-mail s předvyplněnými informacemi.
              </div>
            </div>
            <div>
              <div className="font-medium">Nejde mi položka v menu?</div>
              <div className="text-gray-600">
                Některé stránky mohou být zatím ve vývoji (placeholder).
              </div>
            </div>
            <div>
              <div className="font-medium">Proč nevidím data?</div>
              <div className="text-gray-600">
                Zkontrolujte roli, firmu a pobočku. User vidí jen svou pobočku, RM jen své regiony.
              </div>
            </div>
          </div>
        </div>

        <div className="border rounded-xl p-4">
          <div className="font-semibold mb-2">Kontakt</div>
          <div className="text-sm text-gray-700">
            Technická podpora:{" "}
            <span className="font-medium">jan-juchelka@seznam.cz</span>
          </div>
        </div>
      </div>
    </div>
  );
}